import { Injectable } from '@angular/core';
import { BaseTransactionStrategy } from './base-transaction.strategy';
import { SupplyWarehouseDocumentType } from '../../models/supply-warehouse/supply-warehouse-document-type.enum';
import { GRNStrategy } from './grn.strategy';
import { DispatchRequestStrategy } from './dispatch-request.strategy';
import { MaterialIssueStrategy } from './material-issue.strategy';
import { InternalReturnStrategy } from './internal-return.strategy';
import { ProviderReturnStrategy } from './provider-return.strategy';

/**
 * Factory para crear estrategias de transacciones según el tipo de documento
 * Implementa el patrón Factory para gestionar las diferentes estrategias
 */
@Injectable({
  providedIn: 'root',
})
export class TransactionStrategyFactory {
  constructor(
    private grnStrategy: GRNStrategy,
    private dispatchRequestStrategy: DispatchRequestStrategy,
    private materialIssueStrategy: MaterialIssueStrategy,
    private internalReturnStrategy: InternalReturnStrategy,
    private providerReturnStrategy: ProviderReturnStrategy,
  ) {}

  /**
   * Obtiene la estrategia correspondiente según el tipo de documento
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getStrategy(documentType: SupplyWarehouseDocumentType): BaseTransactionStrategy<any, any> {
    switch (documentType) {
      case SupplyWarehouseDocumentType.GoodsReceiptNote:
        return this.grnStrategy;

      case SupplyWarehouseDocumentType.DispatchRequest:
        return this.dispatchRequestStrategy;

      case SupplyWarehouseDocumentType.MaterialIssue:
        return this.materialIssueStrategy;

      case SupplyWarehouseDocumentType.InternalReturn:
        return this.internalReturnStrategy;

      case SupplyWarehouseDocumentType.ProviderReturn:
        return this.providerReturnStrategy;

      default:
        throw new Error(`Unknown document type: ${documentType}`);
    }
  }

  /**
   * Verifica si una estrategia está implementada
   */
  isStrategyImplemented(documentType: SupplyWarehouseDocumentType): boolean {
    return (
      documentType === SupplyWarehouseDocumentType.GoodsReceiptNote ||
      documentType === SupplyWarehouseDocumentType.DispatchRequest ||
      documentType === SupplyWarehouseDocumentType.MaterialIssue ||
      documentType === SupplyWarehouseDocumentType.InternalReturn ||
      documentType === SupplyWarehouseDocumentType.ProviderReturn
    );
  }
}
